import { useTranslation } from 'react-i18next';
import DurationField from '@/components/fields/DurationField';
import NumberField from '@/components/fields/NumberField';

const IpptInnerForm = () => {
    const { t } = useTranslation('performanceResult');

    return (
        <>
            <div className="grid items-start gap-4 sm:col-span-3 sm:grid-cols-3">
                <NumberField name="pushUps" label={t('ippt.form.pushUps')} min={0} suffixElement={t('ippt.form.rep')} />
                <NumberField name="sitUps" label={t('ippt.form.sitUps')} min={0} suffixElement={t('ippt.form.rep')} />
                <NumberField name="pullUps" label={t('ippt.form.pullUps')} min={0} suffixElement={t('ippt.form.rep')} />
            </div>

            <div className="sm:col-span-2">
                <DurationField
                    name="runTime"
                    units={['minutes', 'seconds']}
                    label={t('ippt.form.runTimeSec')}
                    target="seconds"
                />
            </div>

            <div className="sm:col-span-3">
                <NumberField name="points" label={t('ippt.form.points')} min={0} />
            </div>
        </>
    );
};

export default IpptInnerForm;
